// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carrousel {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex: 1 1;
  height: 100%;
  box-sizing: border-box;
  overflow: scroll;
}
.carrousel-header {
  display: flex;
  gap: 1em;
  align-items: center;
  justify-content: space-between;
}
.carrousel-title {
  font-size: 1.5em;
  font-weight: bold;
}
.carrousel-container {
  flex: 1 1;
  margin-top: 2em;
  margin-inline: 2em;
  padding: 2em;
  border-radius: 1em;
  background-color: #fff;
}
.carrousel-form {
  display: flex;
  flex-direction: column;
}
.carrousel-form-layout {
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 2em;
}

.carrousel-radio-group {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}
.carrousel-radio-group .form-row {
  padding: 0.7em;
}
.carrousel-radio-group .form-radio-group:last-child {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1em;
  flex-wrap: wrap;
  max-height: 8em;
}

.preview-btn {
  margin-bottom: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/views/carrousel/carrouselForm/carrouselForm.scss","webpack://./src/sass/globals/mixins.scss","webpack://./src/sass/globals/globals.scss"],"names":[],"mappings":"AAGA;ECFC,aAAA;EACA,uBDEc;ECDd,uBDCsB;EACtB,SAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AAAD;AAEC;EACC,aAAA;EACA,QAAA;EACA,mBAAA;EACA,8BAAA;AAAF;AAGC;EACC,gBAAA;EACA,iBAAA;AADF;AAIC;EACC,SAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBExBM;AFsBR;AAKC;EACC,aAAA;EACA,sBAAA;AAHF;AAKE;EClCD,aAAA;EACA,6BDkCgB;ECjChB,uBDiC8B;EAC5B,eAAA;EACA,QAAA;AADH;;AAMA;ECpCC,aAAA;EACA,sBAAA;EACA,2BDmCoB;EClCpB,uBDkCgC;EAChC,WAAA;AAAD;AAEC;EACC,cAAA;AAAF;AAGC;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;AADF;;AAKA;EACC,qBAAA;AAFD","sourcesContent":["@import '../../../../sass/globals/globals.scss';\n@import '../../../../sass/globals/mixins.scss';\n\n.carrousel {\n\t@include flex(center, flex-start);\n\tflex: 1;\n\theight: 100%;\n\tbox-sizing: border-box;\n\toverflow: scroll;\n\n\t&-header{\n\t\tdisplay: flex;\n\t\tgap: 1em;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t}\n\n\t&-title {\n\t\tfont-size: 1.5em;\n\t\tfont-weight: bold;\n\t}\n\n\t&-container {\n\t\tflex: 1;\n\t\tmargin-top: 2em;\n\t\tmargin-inline: 2em;\n\t\tpadding: 2em;\n\t\tborder-radius: 1em;\n\t\tbackground-color: $white;\n\t}\n\n\t&-form {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\n\t\t&-layout {\n\t\t\t@include flex(space-evenly, flex-start);\n\t\t\tflex-wrap: wrap;\n\t\t\tgap: 2em;\n\t\t}\n\t}\n}\n\n.carrousel-radio-group {\n\t@include flexColumn(flex-start, flex-start);\n\twidth: 100%;\n\n\t.form-row {\n\t\tpadding: .7em;\n\t}\n\n\t.form-radio-group:last-child{\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\t\tgap: 1em;\n\t\tflex-wrap: wrap;\n\t\tmax-height: 8em;\n\t}\n}\n\n.preview-btn {\n\tmargin-bottom: 0.5rem;\n}","@mixin flex($justify-content, $align-items) {\n\tdisplay: flex;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n\n@mixin flexColumn($justify-content, $align-items) {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n","$dark-red: #8f003c;\n$sidebar-selected-color: #c4145d;\n$sidebar-logo-color: #a53363;\n$logo-color: #920942;\n$white: #fff;\n$grey: #f3f6f9;\n$grey2: #e2e5e7;\n$dark-grey: #777776;\n$font-color: #fff;\n$shadow-color: #4e7da2;\n$font: 'Rubik';\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
